<script setup lang="ts">

import { AppText } from '@shared/ui/typography'
import { ModalConfirmation } from '@shared/ui/modals'

import { useModalDeleteAssignmentTemplate } from '../../../model/assignments/modal-delete-assignment-template.hook'

defineOptions({
  name: 'ModalDeleteAssignmentTemplate',
})

const {
  refIsOpen,
  refIsLoading,
  refDetail,
  closeModal,
  confirmDelete,
} = useModalDeleteAssignmentTemplate()
</script>

<template>
  <ModalConfirmation
    :show="refIsOpen"
    :loading="refIsLoading"
    :disabled="refIsLoading"
    mode="delete"
    title="Delete assignment template"
    button-title="Delete"
    is-close-icon
    @click:confirm="confirmDelete"
    @click:cancel="closeModal"
  >
    <!-- The `detail` prop renders through `v-html`, and the sentence carries an admin-authored
         title — so it goes through the slot, where Vue escapes it. -->
    <template #content>
      <AppText
        name="body1"
        color="slate-700"
      >
        {{ refDetail }}
      </AppText>
    </template>
  </ModalConfirmation>
</template>
